import { IntlProvider } from "react-intl";

import { messages_en } from "./messages/en";
import { messages_it } from "./messages/it";

import { selectLanguage } from "../redux/features/language/languageSlice";
import { useSelector } from "react-redux";

const messages = {
  EN: messages_en,
  IT: messages_it,
};

// const language = navigator.language.split(/[-_]/)[0]; // Detect browser language, fallback to 'en' if necessary

export default function I18nProvider({ children }) {
  const currentLanguage = useSelector(selectLanguage);
  return (
    <IntlProvider
      locale={currentLanguage}
      messages={messages[currentLanguage]}
      defaultLocale="IT"
    >
      {children}
    </IntlProvider>
  );
}
